import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import { PublishPanel } from './PublishPanel';

export interface Publishing {
  id: string;
  title: string;
}

/**
 * A table row's publish — ADMIN-29. The detail page's panel in a dialog rather than a
 * second publish flow, so the rules, the course confirmation and the fill are the same
 * wherever an admin presses Publish.
 */
export function CollectionPublishDialog({
  target,
  onClose,
}: {
  target: Publishing | null;
  onClose: () => void;
}) {
  return (
    <Dialog open={target !== null} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        {target === null ? '' : `Publish “${target.title}”`}
      </DialogTitle>
      <DialogContent>
        {target !== null && <PublishPanel id={target.id} />}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
